export enum FacebookEventEnum {
  PURCHASE = 'Purchase',
  INITIATE_CHECKOUT = 'InitiateCheckout',
  PAGE_VIEW = 'PageView',
}
